// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.fas{font-size:11px;color:#adadad}", "",{"version":3,"sources":["webpack://./resources/insite/js/components/insite/leads/detailHelp.vue"],"names":[],"mappings":"AAAA,SACE,cAAA,CACA,aACF","sourcesContent":["span.fas {\n  font-size: 11px;\n  color: #adadad;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
